import Repository from "./Repository";
const resource = "/api/v1/extra/get-siteSetting";
export default {
  footerInfo() {
    let subUrl = `${resource}`;
    return Repository.sendReq({ method: "get", subUrl,});
  },
};
